import React from "react";
import CONSTANT from "../../../constant";
import { addDashboardLink } from "../../../actions/MasterAction";

class AddDashboardLink extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      title: "",
      sortOrder: "",
      file: null as File | null,
      showLoader: false,
      error: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.adminSection;
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ [e.target.name]: e.target.value, error: "" });
  };

  onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    this.setState({ file, error: "" });
  };

  onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { title, sortOrder, file } = this.state;

    if (!title.trim()) {
      this.setState({ error: "Title is required." });
      return;
    }
    if (!file) {
      this.setState({ error: "Please select a PDF file to upload." });
      return;
    }

    this.setState({ showLoader: true });

    const formData = new FormData();
    formData.append("title", title.trim());
    formData.append("sortOrder", sortOrder || "0");
    formData.append("file", file);

    const res: any = await addDashboardLink(formData);
    this.setState({ showLoader: false });

    if (res?.status === CONSTANT.static.apiStatus.success) {
      alert("Document link added successfully.");
      this.props.history.push(CONSTANT.component.adminDashboardLinkList.url);
    } else {
      this.setState({ error: res?.error || "Failed to add link." });
    }
  };

  onCancel = () => {
    this.props.history.push(CONSTANT.component.adminDashboardLinkList.url);
  };

  render() {
    const { title, sortOrder, showLoader, error } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12 my-3">
                <h1 className="page-title">Add Dashboard Document Link</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card p-4">
                  <form onSubmit={this.onSubmit}>
                    {error && (
                      <div className="alert alert-danger mb-3">{error}</div>
                    )}

                    <div className="form-group mb-3">
                      <label htmlFor="title">
                        Document Title <span className="text-danger">*</span>
                      </label>
                      <input
                        id="title"
                        name="title"
                        type="text"
                        className="form-control"
                        placeholder="e.g. EPI Works Manual"
                        value={title}
                        onChange={this.onChange}
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label htmlFor="sortOrder">Sort Order</label>
                      <input
                        id="sortOrder"
                        name="sortOrder"
                        type="number"
                        className="form-control"
                        placeholder="0"
                        value={sortOrder}
                        onChange={this.onChange}
                      />
                      <small className="text-muted">
                        Lower number appears first in the list.
                      </small>
                    </div>

                    <div className="form-group mb-4">
                      <label htmlFor="file">
                        PDF File <span className="text-danger">*</span>
                      </label>
                      <input
                        id="file"
                        name="file"
                        type="file"
                        className="form-control"
                        accept=".pdf"
                        onChange={this.onFileChange}
                      />
                      <small className="text-muted">
                        Only PDF files are accepted. The server will store the
                        file and return a download URL.
                      </small>
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        type="submit"
                        className="btn submit-button"
                        disabled={showLoader}
                      >
                        {showLoader ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-2" />
                            Uploading...
                          </>
                        ) : (
                          "Upload & Save"
                        )}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={this.onCancel}
                        disabled={showLoader}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddDashboardLink;
